import { GetAllCoursesProgressResponse } from "@shared_types";
import { GetCurrentCourseResponse } from "@/api/Api";
import { DisplayCourse } from "@/hooks/useCourses";
import emojiRegex from "emoji-regex";

export function mapCoursesToDisplayCourses(
  courseResponse: GetAllCoursesProgressResponse,
  currentCourse: GetCurrentCourseResponse
): DisplayCourse[] {
  return courseResponse.courses.map((response) => {
    const course = response.course;
    const progress = response.progress;
    if (course.title === "") {
      return {
        id: course.courseId,
        courseId: course.courseId,
        name: "",
        title: "",
        description: "",
        level: course.level,
        icon: <div>🇪🇸</div>,
        progress: progress,
        isCurrent: false,
        topic: course.topic.id.toString(),
        totalChapters: response.totalChapters,
      };
    }

    // Special case for the mirror emoji (🪞)
    if (course.title.includes("🪞")) {
      const textWithoutEmoji = course.title.replace("🪞", "").trim();
      return {
        id: course.courseId,
        courseId: course.courseId,
        name: textWithoutEmoji,
        title: course.title,
        description: course.description,
        level: course.level,
        icon: <div>🪞</div>,
        progress: progress,
        isCurrent: course.courseId === currentCourse.courseId,
        topic: course.topic.id.toString(),
        totalChapters: response.totalChapters,
      };
    }

    const regex = emojiRegex();
    const match = regex.exec(course.title);
    const icon = match ? match[0] : "🇪🇸";

    const textWithoutEmoji = course.title.replace(regex, "").trim();

    return {
      id: course.courseId,
      courseId: course.courseId,
      name: textWithoutEmoji,
      title: course.title,
      description: course.description,
      level: course.level,
      icon: <div>{icon}</div>,
      progress: progress,
      isCurrent: course.courseId === currentCourse.courseId,
      topic: course.topic.id.toString(),
      totalChapters: response.totalChapters,
    };
  });
}
